export function mod(num, modBy){
    return(((num % modBy) + modBy) % modBy);
}